import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'auth/AuthProvider';
import { queryKeys } from 'core/api/queryKeys';
import { paths } from 'core/routing/paths';
import { companyApi } from 'features/company/company.api';
import { canAccessCompanyRoute, resolveCompanyPermissions } from 'features/company/companyPermissions';
import { Skeleton } from 'shared/components/Feedback';
import { CompanyContext } from 'features/company/CompanyContext';

export function CompanyMemberRoute({ children }) {
  const location = useLocation();
  const { user } = useAuth();
  const query = useQuery({
    queryKey: queryKeys.companyBootstrap,
    queryFn: () => companyApi.resolveSession(user?.id),
    enabled: Boolean(user?.id),
    retry: false,
  });

  if (!user?.id || query.isLoading) {
    return <Skeleton rows={6} />;
  }

  if (query.isError || !query.data?.company) {
    return <Navigate to={paths.companyOnboarding} replace state={{ returnTo: location.pathname }} />;
  }

  const membership = query.data.membership || {};
  const permissions = resolveCompanyPermissions(membership);

  if (!canAccessCompanyRoute(location.pathname, permissions)) {
    return <Navigate to={paths.forbidden} replace />;
  }

  const value = {
    company: query.data.company,
    companyId: query.data.company.id,
    membership,
    permissions,
    dashboard: query.data.dashboard || {},
    refetch: query.refetch,
  };

  return (
    <CompanyContext.Provider value={value}>
      {children || <Outlet />}
    </CompanyContext.Provider>
  );
}
